import { useEffect, useRef, useState } from "react"
import { IRazonDTO } from "../../../../Interfaces/auxiliar/IRazon"
import { Ifilter } from "../../../../Interfaces/filter"
import { ISearchBox } from "@fluentui/react";
import { RazonService } from "../../../../services/auxiliar/RazonService"
import { IPaginationV2 } from "../../../../Interfaces/base/ITable"

export const UseRazon = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const onChangeSearch = useRef<ISearchBox>(null);
  const [items, setItems] = useState<IRazonDTO[]>([])
  const [filter, setFilter] = useState<Ifilter>({
    skip: 0,
    take: 50,
  });

  const inital: Ifilter = {
    skip: 0,
    take: 50,
  }

  const _onkeyUpSearchTable = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    let { value } = event?.target as HTMLInputElement;
    setFilter({ ...filter, search: value });
  };

  const onChangeTake = (value: number) => {
    setFilter({ ...filter, take: value })
  };
  const onSkip = (value: number) => {
    const realSkip = (value * filter.take) - filter.take
    setFilter({ ...filter, skip: realSkip })
  };
  const [pagination, setPagination] = useState<IPaginationV2>({
    currentPage: 0,
    total: 0,
    pageSize: 0,
    skip: 0,
    take: 50,
    onPageChange: function (value: number): void {
    },
    onSizeChange: function (value: number): void {
    }
  })
  const handleResetUpdate = () => {
    setFilter(inital);
  };

  const getRazones = () => {
    setLoading(true)
    RazonService.ListarRazones(filter).then((res) => {
      const pag: IPaginationV2 = {
        currentPage: res.data.page,
        total: res.data.total,
        pageSize: res.data.pages,
        onPageChange: onSkip,
        skip: filter.skip,
        take: filter.take,
        onSizeChange: onChangeTake
      };
      setPagination(pag)
      setLoading(false)
      setItems(res.data.items)
    }).catch((e: any) => {
      setLoading(false)
    })

  }
  useEffect(() => {
    if (filter) {
      getRazones()
    }
  }, [filter])

  return {
    items,
    filter,
    setFilter,
    loading,
    pagination,
    getRazones,
    handleResetUpdate,
    onChangeTake,
    _onkeyUpSearchTable,
    onChangeSearch
  }
}